
import { defineComponent, onMounted } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { loadPaginatedECSales } from "@/api/onlineshop";

export default defineComponent({
  name: "retailsales",
  props: {
    widgetClasses: String,
  },
  data() {
    return {
      list: [],
      loading: true,
    };
  },
  mounted() {
    this.loadPaginatedECSales();
  },
  methods: {
    async loadPaginatedECSales() {
      this.loading = true;
      const response = await loadPaginatedECSales(1);
      this.list = response.data.pageList;
      this.loading = false;
    },
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Online Shop");
    });
  },
});
